import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SideButtons from './SideButtons';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="flex flex-col min-h-screen relative">
            <Header />
            <div id="main-content" className="flex-grow">
                <main>{children}</main>
            </div>
            <SideButtons />
            <Footer />
        </div>
    );
};

export default Layout;